module.exports = __webpack_public_path__ + "img/EP_AXVV-02.05ad8128.png";